export default "__VITE_ASSET__CHpByaO0__"